<template>
  <a-row :gutter="8" :class="getScreen ? 'm-list-wrapper' : 'd-list-wrapper'">
    <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
      <a-card>
        <div slot="title"><a-icon type="file-search" />&nbsp;Search</div>
        <ul class="m-list-wrapper">
          <li>
            <a-input-search v-model="search" placeholder="Quick Search" />
          </li>
          <li>
            <a-collapse :activeKey="getScreen ? 0 : 1">
              <a-collapse-panel key="1">
                <span slot="header">Search More...</span>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Transaction Date</label>
                  <a-range-picker :placeholder="['Start Date', 'End Date']" v-model="searchDate"
                    :format="getDefaultDateFormat" allowClear />
                </div>
                <!-- Fitur Tertunda -->
                <!-- <div class="m-form-item-wrapper">
                  <label for="kategori">Kategori</label>
                  <a-select
                    placeholder="Ex: Project ... "
                    v-model="kategori"
                    class="width-full"
                    allowClear
                  >
                    <a-select-option
                      v-for="item in getKategori"
                      :key="item.id"
                      :value="item.value"
                    >{{item.label}}</a-select-option>
                  </a-select>
                </div>-->
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Status</label>
                  <a-select placeholder="Ex: Approved ... " v-model="status" class="width-full" initialValue="delivered"
                    allowClear>
                    <a-select-option v-for="item in getStatusLapUMPD" :key="item.id" :value="item.value">{{ item.label
                    }}</a-select-option>
                  </a-select>
                </div>
              </a-collapse-panel>
            </a-collapse>
          </li>
        </ul>
      </a-card>
    </a-col>
    <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
      <DataList :loading="loading" title="UM PD Report List" :manifestLink="getManifestLink" :dataList="searching"
        :price="true" :disabledCreateEditLink="true" :isMonitoring="true" />
    </a-col>
  </a-row>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import axios from "axios";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import _ from "lodash";

export default {
  name: "ListLaporanUmPd",
  mixins: [CurrencyFormat],
  data() {
    return {
      loading: true,
      dataList: [],
      kategori: "",
      searchDate: [],
      search: "",
      status: undefined,
    };
  },
  mounted() {
    this.fetchData();
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getStatusLapUMPD",
      "getKategori",
      "getDefaultDateFormat",
      "getStandartFormatDate",
    ]),
    searching() {
      var self = this;
      let outputData = this.dataList;

      if (this.search) {
        outputData = _.filter(
          outputData,
          (obj) =>
            obj.searchQ &&
            obj.searchQ.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
        );
      }

      if (this.searchDate && this.searchDate.length > 0) {
        let startDt = moment(this.searchDate[0], this.getDefaultDateFormat).format(this.getStandartFormatDate);
        let endDt = moment(this.searchDate[1], this.getDefaultDateFormat).format(this.getStandartFormatDate);
        outputData = outputData.filter(
          (obj) =>
            obj.tgl_mulai && obj.tgl_selesai &&
            moment(obj.tgl_mulai, this.getStandartFormatDate).format(this.getStandartFormatDate) >= startDt &&
            moment(obj.tgl_selesai, this.getStandartFormatDate).format(this.getStandartFormatDate) <= endDt
        );
      }

      if (this.status) {
        outputData = _.filter(
          outputData,
          (obj) =>
            obj.status &&
            obj.status.toLowerCase().indexOf(self.status.toLowerCase()) >= 0
        );
      }

      return outputData;
    },
    getManifestLink() {
      let manifest = "";
      if (localStorage.getItem("nvpn") === "/keuangan") {
        manifest = "SpclLapUMPDManifestKeu";
      } else if (localStorage.getItem("nvpn") === "/pimpro") {
        manifest = "SpclLapUMPDManifestPimpro";
      } else if (localStorage.getItem("nvpn") === "/atasanLangsung") {
        manifest = "SpclLapUMPDManifestAL";
      } else if (localStorage.getItem("nvpn") === "/direktur") {
        manifest = "SpclLapUMPDManifestDir";
      } else if (localStorage.getItem("nvpn") === "/verifikatorPelaporan") {
        manifest = "SpclLapUMPDManifestVP";
      } else if (localStorage.getItem("nvpn") === "/akuntansiKeuangan") {
        return "SpclLapUMPDManifestAcc";
      } else if (localStorage.getItem("nvpn") === "/vpf") {
        return "SpclLapUMPDManifestVpf";
      } else if (localStorage.getItem("nvpn") === "/FinancialControl") {
        return "SpclLapUMPDManifestFin";
      } else if (localStorage.getItem("nvpn") === "/marketing") {
        return "SpclLapUMPDManifestMar";
      } else {
        manifest = "SpclWOManifest_";
      }
      return manifest;
    },
  },
  methods: {
    moment,
    fetchData() {
      axios({
        method: "get",
        url: this.$serviceUrl + "monitoring/lap_um_pds",
        params: {
          tlc: this.getAuth.username,
          jenis: "Laporan",
          id: localStorage.getItem("nvky"),
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          _.forEach(response.data.data, (data) => {
            this.dataList.push({
              title: data.no_lk,
              subdesc: [
                [
                  {
                    label: moment(data.tgl_buat).format(
                      this.getDefaultDateFormat
                    ),
                    value: "",
                  },
                ],
                [
                  {
                    label: this.formatCurrency(
                      data.currency,
                      data.total_pemakaian
                    ),
                    value: "",
                  },
                ],
                [
                  {
                    label: "Type : " + (data.isparsial == "1" ? "PARSIAL" : "FINAL"),
                    value: "",
                  },
                ],
              ],
              timeline: JSON.parse(data.status_app),
              unread: data.unread == "1" ? true : false,
              status: data.status,
              id: data.id_manifest,
              price: data.grand_total,
              mata_uang: data.currency,
              tgl_buat: data.tgl_buat,
              searchQ:
                data.no_lk +
                " " +
                data.tlc_pembuat +
                " " +
                this.formatCurrency(data.currency, data.total_pemakaian)
                  .toString()
                  .toLowerCase(),
            });
          });

          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style></style>